export default "__VITE_ASSET__CnFSj7HP__"